"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setUser = setUser;

var _ActionTypes = require("lead-flows-ui/constants/ActionTypes");

var _UserUtils = require("lead-flows-ui/utils/UserUtils");

function setUser(userInfo) {
  return {
    type: _ActionTypes.SET_USER,
    user: {
      userId: userInfo.user_id,
      email: userInfo.email,
      firstName: userInfo.first_name,
      lastName: userInfo.last_name,
      fullName: (0, _UserUtils.getFullName)(userInfo.first_name, userInfo.last_name),
      locale: userInfo.locale,
      roles: userInfo.roles
    }
  };
}